import { useEffect, useMemo, useState } from 'react'

import { DSAlert, DSCircularLoading, DSPagination } from '@vr/ds-react'

import { Actions } from '@/components/actions'
import ModalRequestLogistics from '@/compositions/modal-request-logistics'
import ModalRequestLogisticsError from '@/compositions/modal-request-logistics-error'
import ModalRequestLogisticsSuccess from '@/compositions/modal-request-logistics-success'
import { OperatorUnits } from '@/compositions/operator-units'
import { useGeneralContext } from '@/contexts/general.context'
import { formatDateToBR } from '@/utils/format-date-to-br'

const PAGE_SIZE = 10

export const OperatorsList = () => {
  const [requestLogistics, setRequestLogistics] = useState(false)
  const [requestLogisticsSuccess, setRequestLogisticsSuccess] = useState(false)
  const [requestLogisticsError, setRequestLogisticsError] = useState(false)

  const {
    tableData,
    selectItems,
    operator,
    activeDrawer,
    setActiveDrawer,
    isLoading,
    handleFilter,
    handleLimitChange,
    currentFilters,
    results,
    limit,
    setPage
  } = useGeneralContext()

  useEffect(() => {
    handleLimitChange(PAGE_SIZE)
  }, [])


  const mappedData = useMemo(() => {
    return tableData.map(item => {
      return {
        ...item,
        dataLiberacao: formatDateToBR(new Date(item.dataLiberacao))
      }
    })
  }, [tableData])

  return (
    <>
      {isLoading && <DSCircularLoading isLoading shouldBlur={true} />}

      {!isLoading && mappedData.length === 0 && (
        <DSAlert
          type='info'
          title={'Sem resultados para os filtros selecionados'}
          css={{ marginTop: '$sm16' }}
          hiddenBtnClose
        >
          Tente ajustar os filtros para exibir os resultados desejados
        </DSAlert>
      )}

      {mappedData.map(item => (
        <OperatorUnits
          key={item.idOperadora + item.dataLiberacao}
          data={item}
        />
      ))}

      <DSPagination
        total={results}
        maxPerPage={limit}
        handleChange={(newPage: number) => setPage(newPage)}
        nextPreview
        siblingCount={1}
      />

      {selectItems.length > 0 && (
        <Actions
          onClose={() => setActiveDrawer(false)}
          onRequestLogistics={() => setRequestLogistics(true)}
          open={activeDrawer}
          operator={operator}
          selectedItems={selectItems}
        />
      )}

      {requestLogistics && (
        <ModalRequestLogistics
          onClose={() => setRequestLogistics(false)}
          operator={operator}
          items={selectItems}
          setRequestLogisticsSuccess={setRequestLogisticsSuccess}
          setRequestLogisticsError={setRequestLogisticsError}
        />
      )}

      <ModalRequestLogisticsSuccess
        show={requestLogisticsSuccess}
        onClose={() => {
          setRequestLogisticsSuccess(false)
          handleFilter(currentFilters)
        }}
      />

      <ModalRequestLogisticsError
        show={requestLogisticsError}
        onClose={() => setRequestLogisticsError(false)}
      />
    </>
  )
}
